import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminArticles from "./pages/AdminArticles";
import AdminGallery from "./pages/AdminGallery";
import AdminContent from "./pages/AdminContent";
import AdminPassword from "./pages/AdminPassword";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ContentProvider>
                    <AuthProvider>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/merch"
                                element={
                                    <ProtectedRoute>
                                        <AdminArticles />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/gallery"
                                element={
                                    <ProtectedRoute>
                                        <AdminGallery />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/content"
                                element={
                                    <ProtectedRoute>
                                        <AdminContent />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/password"
                                element={
                                    <ProtectedRoute>
                                        <AdminPassword />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </AuthProvider>
                </ContentProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
